/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./boost.vue?vue&type=template&id=42a45b3c&scoped=true"
import script from "./boost.vue?vue&type=script&lang=js"
export * from "./boost.vue?vue&type=script&lang=js"
import style0 from "./boost.vue?vue&type=style&index=0&id=42a45b3c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a45b3c",
  null
  
)

export default component.exports